import { createContext, useEffect, useState } from "react"
import ContentService from "../services/ContentService";

const AppContext = createContext();

export const AppContextProvider = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const [mainPageNews, setMainPageNews] = useState([])

    useEffect(() =>
    {
        const service = new ContentService();
        service.getAllContentsByCategoryAndNumber(1, 9999)
            .then(resp =>
            {
                setLoading(false);
                setMainPageNews(resp);
            })
    }, [])

    const values = {
        loading,
        setLoading,
        mainPageNews,
        setMainPageNews
    }

    return <AppContext.Provider value={values}>{children}</AppContext.Provider>
}

export default AppContext;